import { render, staticRenderFns } from "./modalInput.vue?vue&type=template&id=c0868fbc"
import script from "./modalInput.vue?vue&type=script&lang=js"
export * from "./modalInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports